export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9369.bfeb4fd3.jpg";